import { InstructionRSJIncomeType } from '../../../../shared/models/enums/Instruction-rsj-income-type.enum';

export class RsjInstructionIncomeDto {
  constructor(
    public id?: number,
    public type?: InstructionRSJIncomeType,
    public previousMonth?: number,
    public currentMonth?: number,
    public nextMonth?: number,
    public nextTwoMonth?: number,
    public nextThreeMonth?: number,
  ) {}
}
